import {styled} from "@mui/material";
import ThemedText from "../../../components/text";
import Label from "../../../resources/label";
import Base from "../../../components/base";
import LoginForm from "../../../components/form/login";
import {useNavigate} from "react-router-dom";
import {scale} from "../../../utils";


const Wrapper = styled('div')({
  maxWidth: scale(1592),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginTop: scale(50),
  rowGap: scale(38),
});

const AdminLogin = () => {
  const navigate = useNavigate();
  return (
    <Wrapper>
      <ThemedText
        fontSize={scale(42)}
        align={'center'}
        fontWeight={300}
        lineHeight={scale(52)}
        letterSpacing={scale(0.42)}
        text={Label.ADMIN_LOGIN_HEADER}
      />
      <Base
        style={{
          width: scale(500),
          height: scale(560),
      }}>
        <LoginForm
          style={{
            marginTop: scale(50),
            marginBottom: scale(58),
            height: '100%',
          }}
          onLoginSuccess={() => navigate('/admin/crea-operatore')}
          admin={true}
        />
      </Base>
    </Wrapper>
  );
};

export default AdminLogin;
